import { Add } from "@mui/icons-material";
import { Button, Typography } from "@mui/material";
import React from "react";
import { defaultExtraction } from "./ConfigDefault";
import { useFormConfigContext } from "./ConfigFormContext";

const ConfigNoExtraction: React.FC = () => {
  const { setValue } = useFormConfigContext();

  return (
    <>
      <Typography className="italic">
        Une extraction vous aide à obtenir des informations contenues dans le
        document.
      </Typography>

      <div className="flex justify-center">
        <Button
          variant="contained"
          onClick={() => setValue("config.extraction", defaultExtraction())}
          className="gap-2"
        >
          <Add />
          Extraction
        </Button>
      </div>
    </>
  );
};
export default ConfigNoExtraction;
